"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorTranslationKeys = exports.MetricOperator = void 0;
var MetricOperator;
(function (MetricOperator) {
    MetricOperator["Q75th"] = "Q75th";
    MetricOperator["Median"] = "Median";
    MetricOperator["Average"] = "Average";
})(MetricOperator = exports.MetricOperator || (exports.MetricOperator = {}));
exports.operatorTranslationKeys = {
    [MetricOperator.Q75th]: 'METRIC.OPERATOR.Q75TH',
    [MetricOperator.Median]: 'METRIC.OPERATOR.MEDIAN',
    [MetricOperator.Average]: 'METRIC.OPERATOR.AVERAGE',
};
//# sourceMappingURL=operator.js.map